import * as Incident from '../schemas/inductions/Kmart/supplementalForms/Incident.json'
import * as Permit from '../schemas/inductions/Kmart/supplementalForms/Permit.json'

export default {
    type: 'Kmart Supplementals',
    schemas: {
        'Incident': Incident,
        'Permit': Permit,
    }
}